import { supabase } from '@shared/supabase/client';

/**
 * Fire-and-forget: ask the server to flush the email queue now, so a just-enqueued
 * notification (collab proposal, campaign application, broadcast) goes out immediately
 * instead of waiting for the daily-cron sweep. Any authenticated user may trigger it —
 * queued rows are already-approved content. Never throws; failures just fall back to the
 * daily cron.
 */
export async function flushEmailQueue(): Promise<void> {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session) return;
    await fetch('/api/send-emails?queue=1', {
      method: 'POST',
      headers: { Authorization: `Bearer ${session.access_token}` },
      keepalive: true,
    });
  } catch {
    /* best-effort — the daily cron will pick up anything left queued */
  }
}
